import { ptBR } from '@/i18n/pt-BR';
import {
  abreviarCodigo,
  formatarRecebimento,
  type DocumentoRegistrado,
  type TipoDocumentoRegistrado,
} from '@/lib/cadeia_custodia';
import {
  MonoData,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui';

const t = ptBR.cadeiaCustodia;

// Um tipo novo no backend precisa entrar aqui, ou o TypeScript acusa o
// `Record` incompleto — a chave crua nunca chega à tela.
const ROTULO_DO_TIPO: Record<TipoDocumentoRegistrado, string> = {
  captura_da_mesa: t.tipoCapturaDaMesa,
  protocolo_importado: t.tipoProtocoloImportado,
  laudo_certificado: t.tipoLaudoCertificado,
};

export interface DocumentosRegistradosTabelaProps {
  documentos: DocumentoRegistrado[];
}

/**
 * A segunda lista do registro (E85.F2 — GUS-32): o que o sistema PRODUZIU, com // ux-neutrality:allow doc-comment
 * o código gravado no momento da produção. Separada das peças de propósito: a // ux-neutrality:allow doc-comment
 * primeira lista responde "não foi esse arquivo que vocês periciaram"; esta // ux-neutrality:allow doc-comment
 * responde "esse documento saiu daqui assim". // ux-neutrality:allow doc-comment
 */
export function DocumentosRegistradosTabela({
  documentos,
}: DocumentosRegistradosTabelaProps): JSX.Element {
  return (
    <div className="mt-sc-6" data-testid="documentos-registrados">
      <h3 className="text-heading-sm font-semibold text-fg">{t.documentosTitulo}</h3>
      <p className="mt-sc-1 max-w-3xl text-body-sm text-fg-muted">{t.documentosDescricao}</p>
      {documentos.length === 0 ? (
        <p
          className="mt-sc-3 text-body-sm text-fg-muted"
          data-testid="documentos-registrados-vazio"
        >
          {t.documentosVazio}
        </p>
      ) : (
        <div className="mt-sc-3 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t.colDocumento}</TableHead>
                <TableHead>{t.colProduzidoPor}</TableHead>
                <TableHead>{t.colProduzidoEm}</TableHead>
                <TableHead>{t.colCodigo}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {documentos.map((documento) => (
                <TableRow key={documento.id} data-testid="documentos-registrados-linha">
                  <TableCell>
                    <span className="text-caption uppercase tracking-wide text-fg-muted">
                      {ROTULO_DO_TIPO[documento.tipo]}
                    </span>
                    <span className="block text-body-sm text-fg">{documento.descricao}</span>
                  </TableCell>
                  <TableCell className="text-body-sm text-fg">{documento.produzido_por}</TableCell>
                  <TableCell className="text-body-sm text-fg">
                    {formatarRecebimento(documento.produzido_em)}
                  </TableCell>
                  <TableCell>
                    {documento.sha256 === null ? (
                      <span className="text-body-sm text-fg-muted">{t.semCodigo}</span>
                    ) : (
                      <MonoData
                        className="text-body-sm text-fg"
                        title={documento.sha256}
                        data-testid="documentos-registrados-codigo"
                      >
                        {abreviarCodigo(documento.sha256)}
                      </MonoData>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
